export default __webpack_public_path__ + "static/lounge-business-analytics-64b59f5e1c1371bdc7b8bafa7a568eb1.png";